<template>
  <div v-if="includedInSub">
    <div
      v-if="shortCard"
      class="static border-l-8 relative bg-white h-full rounded shadow-md border-purple w-full"
      :class="!includedInSub ? 'opacity-50' : ''"
    >
      <div
        id="card-content"
        class="p-4"
      >
        <div
          id="card-top"
          class="pb-4 border-b-2 border-matte-gray flex justify-start items-center"
        >
          <img
            src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/core-plus-icon.png"
            class="mr-4"
            :class="large ? 'h-14' : 'h-10'"
          />
          <h5
            class="leading-tight text-left"
            :class="large ? 'text-2xl' : ''"
          >
            Core100+ Subscription
          </h5>
        </div>
        <div
          id="card-bottom"
          class="pt-4 text-center"
        >
          <p class="text-sm font-bold">
            Top 100 Online Courses for Your Profession <b class="text-pink">PLUS</b> 2 Select Live Webinars Each Month
          </p>
          <div class="absolute inset-x-0 bottom-4 text-center">
            <p
              v-if="discountedPrice.length > 0 && discountedPrice !== pricesStore.core100P"
              class="py-4 text-sm"
            >
              Only <span class="line-through">${{ pricesStore.core100P }}year</span>
              <br />
              Discounted price: {{ discountedPrice }}!
            </p>
            <p
              v-else
              class="py-4 text-sm"
            >
              Only ${{ pricesStore.core100P }}/year
            </p>
            <slot name="button" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="relative border-l-8 rounded bg-white h-full shadow-md border-purple w-full"
      :class="!includedInSub ? 'opacity-50' : ''"
    >
      <div
        id="long-card-content"
        class="p-4"
      >
        <div
          id="long-card-top"
          class="pb-4 border-b-2 border-matte-gray"
        >
          <div class="flex justify-start items-center">
            <img
              src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/core-plus-icon.png"
              class="mr-4"
              :class="large ? 'h-14' : 'h-10'"
            />
            <h5
              class="leading-tight text-left"
              :class="large ? 'text-2xl' : ''"
            >
              Core100+ Subscription
            </h5>
          </div>
          <p class="text-sm font-bold pt-4">
            Top 100 Online Courses for Your Profession <b class="text-pink">PLUS</b> 2 Select Live Webinars Each Month
          </p>
        </div>
        <div
          id="long-card-bottom"
          class="pt-4 text-center"
        >
          <p class="font-bold text-sm text-left pb-2">
            Get Unlimited Access to:
          </p>
          <ul class="text-left">
            <li class="text-sm mb-1">
              <span class="font-bold text-purple">Top 100 Online Courses</span> for your profession
            </li>
            <li class="text-sm mb-1">
              <span class="font-bold text-purple">2 Select Live Webinars</span> Each Month
            </li>
          </ul>
          <div v-if="upgradeOffer.length > 0">
            <p class="font-bold text-lg">
              {{ upgradeOffer }}
            </p>
          </div>
          <slot name="button" />
          <p
            v-if="!upgradeOffer.length > 0"
            class="self-end pt-4 font-bold text-sm"
          >
            Only ${{ pricesStore.core100P }}/year
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores, } from 'pinia';
import { usePriceStore, } from '../../stores/prices';

export default {
  name: 'CorePlus',
  props: {
    shortCard: {
      type: Boolean,
      default: true,
    },
    large: {
      type: Boolean,
      default: true,
    },
    includedInSub: {
      type: Boolean,
      default: true,
    },
    discountedPrice: {
      type: String,
      default: '',
    },
    upgradeOffer: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapStores(usePriceStore),
  },
};
</script>
